import { withInstall } from '../../../utils/with-install'
import Polygon from './Polygon.vue'

export const ElAmapPolygon = withInstall(Polygon)
export default ElAmapPolygon
